import styled from 'styled-components';

import { getThemeColor, media } from '@utils/styled';

import Typography from '@common/components/Typography';

export const CostsInfoWrapper = styled.div`
  display: block;
  border-top: 1px solid ${getThemeColor('bluegrey.80')};
  border-bottom: 1px solid ${getThemeColor('bluegrey.80')};
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'scale', 3)};
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 3)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'section', 2)};
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 0)};

  ${media.from640up`
    display: flex;
  `}
`;

export const CostsItemInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 3)};

  &:last-child {
    margin-bottom: 0;
  }

  ${media.from640up`
    width: 50%;
    margin-bottom: 0;
  `}
`;

export const Heading = styled(Typography).attrs({
  variant: 'h5',
  customAs: 'h5',
})``;

export const Price = styled(Typography).attrs({
  variant: 'h2',
  customAs: 'h4',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'equal', 4)};
`;

export const AdditionalInfo = styled(Typography).attrs({
  variant: 'body2',
  customAs: 'span',
})`
  color: ${getThemeColor('bluegrey.60')};
`;

export const PriceAdditionalInfo = styled(Typography).attrs({
  variant: 'body1',
})`
  color: ${getThemeColor('bluegrey.60')};
  font-weight: 700;
`;
